import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBing = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlSpace: "preserve",
	fill: "none",
	viewBox: "-173 0 1024 1024",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			fill: "url(#bing-a)",
			d: "M0 778.3c14.6 123.8 223.8 143 236.8 79.9-.3-.4-.5-678.1-.5-678.1-3.6-46-26.2-72-61.6-96.5-33-22.7-74.4-50.4-96.9-66.4C14.2-28 .1 31.4 0 33.2c0 0 .3 746.4 0 745.1z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "url(#bing-b)",
			d: "M236.8 832.8c-96.2 72.5-217 42.7-234.4-44-.8-4.2-2.4-10.4-2.4-10.4s.9 8.5 2 16.6c1.2 8.5 3.7 20.8 6.3 31.3 30 117.8 132.1 186 230.4 196.6C373.3 1034.8 497.4 931 599 855.8c6.3-6.2 15.4-16.2 18.1-20.1 66.2-95-13.6-197-72.5-193a59154 59154 0 0 0-307.7 190.1Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "url(#bing-c)",
			fillRule: "evenodd",
			d: "M312.8 381c7.4 47 34.6 108.7 59.6 172.6 20.2 41.3 62 53.4 103 65.5 42.4 12.6 65.6 21 85.6 30.9 138.5 68.7 38.5 207.7 59.6 181.4 89-110.7 79.7-325.4-90-418.1-57.6-28.7-115.4-66.6-156.5-83.6-41-17-68.7 4.3-61.3 51.3z",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "bing-c",
				cx: 0,
				cy: 0,
				r: 1,
				gradientTransform: "matrix(-347 -399.3 287.3 -249.8 655 722)",
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#00CACC" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#048FCE"
				})]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "bing-b",
				cx: 0,
				cy: 0,
				r: 1,
				gradientTransform: "matrix(526 -225.4 375.6 876.6 88.8 915.1)",
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#00BBEC" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#2756A9"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "bing-a",
				x1: 118.4,
				x2: 118.4,
				y1: 0,
				y2: 884.4,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#00BBEC" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#2756A9"
				})]
			})
		] })
	]
});
const ForwardRef = forwardRef(SvgBing);
export { ForwardRef as ReactComponent };
